<template>
  <div v-if="userType !== '4'">
    <div class="row">
      <div class="col-xl-6 col-lg-6">
        <PrePostTotalByObjects />
      </div>
      <div class="col-xl-6 mb-3 mb-xl-0">
        <PrePostTotalByYear />
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-6 mb-3 mb-xl-0">
        <PrePostTotalByMonth />
      </div>
      <div class="col-xl-6 mb-3 mb-xl-0">
        <PrePostTotalByState />
      </div>
    </div>
  </div>
</template>
<script>
import PrePostTotalByMonth from "@/xpost/charts/PrePostTotalByMonth";
import PrePostTotalByYear from "@/xpost/charts/PrePostTotalByYear";
import PrePostTotalByState from "@/xpost/charts/PrePostTotalByState";
import PrePostTotalByObjects from "@/xpost/charts/PrePostTotalByObjects";
import { UserService } from "@/services/users/user.services";

export default {
  name: "Workarea",
  components: {
    PrePostTotalByMonth,
    PrePostTotalByYear,
    PrePostTotalByState,
    PrePostTotalByObjects,
  },
  data() {
    return {
      userType: "4",
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },

};
</script>
